import React from 'react';
import { Field, CccisdToggle } from 'cccisd-formik';
import { widgetBuilder } from 'cccisd-laravel-appdefs';

export const initialValues = {
    show: true,
    chart: {
        verticalScaleMin: 0,
        verticalScaleMax: 3,
    },
};

const Component = props => {
    return (
        <div>
            <Field name="show" component={CccisdToggle} label="Show Charts?" />
        </div>
    );
};

export default widgetBuilder({ initialValues })(Component);
